import React from 'react';
import { inputBase, inputFocused } from './inputStyles';

export default function DarkInput({ style = {}, className = '', ...props }) {
  const [focused, setFocused] = React.useState(false);
  return (
    <input
      {...props}
      className={className}
      style={{ ...inputBase, ...(focused ? inputFocused : {}), ...style }}
      onFocus={e => { setFocused(true); props.onFocus?.(e); }}
      onBlur={e => { setFocused(false); props.onBlur?.(e); }}
    />
  );
}
